import React, { useState, useRef, useEffect } from "react";

const EMOJIS = ["👍", "❤️", "😂", "😮", "😢"];

function MessageActions({ isMe, onDelete, onEdit, onReply, onReact }) {
  const [open, setOpen] = useState(false);
  const [showEmojis, setShowEmojis] = useState(false);
  const ref = useRef(null);

  // Click outside listener taaki menu apne aap band ho jaye
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setShowEmojis(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div
      className="chat-actions position-relative"
      ref={ref}
      style={{ display: "inline-block" }}
    >
      {/* Three dots button */}
      <button
        className="btn btn-sm text-muted"
        onClick={() => setOpen((p) => !p)}
      >
        <i className="ti ti-dots-vertical"></i>
      </button>

      {open && (
        <div
          className="dropdown-menu show shadow-sm border-0"
          style={{ zIndex: 1000 }}
        >
          {/* Quick Emoji Bar inside actions */}
          <div className="d-flex px-2 py-1 border-bottom gap-1">
            {EMOJIS.map((emoji) => (
              <button
                key={emoji}
                className="btn btn-sm btn-light p-1"
                onClick={() => {
                  onReact(emoji);
                  setOpen(false);
                }}
              >
                {emoji}
              </button>
            ))}
          </div>

          <button
            className="dropdown-item py-2"
            onClick={() => {
              onReply();
              setOpen(false);
            }}
          >
            <i className="ti ti-arrow-back-up me-2"></i> Reply
          </button>

          {isMe && (
            <>
              {/* <button className="dropdown-item py-2" onClick={() => { onEdit(); setOpen(false); }}>
                <i className="ti ti-pencil me-2"></i> Edit
              </button> */}
              <button
                className="dropdown-item py-2 text-danger"
                onClick={() => {
                  onDelete();
                  setOpen(false);
                }}
              >
                <i className="ti ti-trash me-2"></i> Delete
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MessageActions;
